import cadeau from "../img/cadeau.png";
import panneau from "../img/panneau.png";
import alert from "../img/alert.png";
import banniere from "../img/08-primedenoel_720.png"; 
import InfoBulle from './info';

const getMontantPrime = ( couple , enfants)=>{
  let montant ;
  if(couple){
    switch(enfants){
      case 0 : montant = 228.67 ; break;
      case 1 : montant = 274.40 ; break;
      case 2 : montant = 320.14; break;
      case 3 : montant = 381.12; break;
      case 4 : montant = 442.10 ; break;
      default : montant = 442.10 + (60.98 * (enfants - 4)); break;
    }
  }else {
              
    switch(enfants){
      case 0 : montant = 152.45; break;
      case 1 : montant = 308.72; break;
      case 2 : montant = 370.45; break;
      case 3 : montant = 452.78; break;
      case 4 : montant = 535.10; break;
      default : montant = 535.10 + (82.32 * (enfants - 4)); break;
    }
  }
  return montant
}

/* key 2 et + */
const getMontantPrimeAlter = ( couple , enfants)=>{
  let montant ;
  if(couple){
    switch(enfants){
      default : montant = 152.45; break;
    }
  }else {
              
    switch(enfants){
      case 0 : montant = 152.45; break;
      case 1 : montant = 205.81; break;
      case 2 : montant = 232.49; break;
      case 3 : montant = 248.49; break;
      case 4 : montant = 269.84; break;
      default : montant = 269.84 + (21.34 * (enfants - 4)); break;
    }
  }
  return montant
}


export default function Resultat  (props) {

  let responseKeys = Object.keys(props.answers);
  let infoR = <small>
              <img src={alert} className="alert-little-box" /> Si vous avez perçu votre premier versement RSA au mois de décembre 2023, la prime de Noël vous sera versée au mois de janvier 2024. <br/><br/>
              Notez qu'il s'agit d'une simulation qui n'a pas de caractère officiel.
            </small>;
  let message = <div>
    Désolé, selon les informations que vous nous avez fournies, vous ne pouvez pas bénéficier de la prime de Noël. <br/>
    <a href="tel:0891150451">
      <img src={banniere} alt="contact" />
    </a>
    <small className="topmargin">
      Notez qu'il s'agit d'une simulation qui n'a pas de caractère officiel.
    </small>
  </div>; // 
  let mois = "décembre"; //

  let positive = false;



  responseKeys.forEach( (key) =>{
    console.log(props.answers[key],key);
    if (!isNaN ( key ) && props.answers[key] === 0) {
      positive = true;

      if (key == 1 ) {
        let montantPrime = getMontantPrime(props.answers.couple ,  props.answers.enfants.number);
        message = (
          <div>
            Selon les informations que vous nous avez fournies, vous devriez percevoir<br/>
            <strong>{montantPrime} €</strong> le 15 décembre 2023 <InfoBulle message={infoR}  />
            <br/>
            
            { !props.answers.couple && props.answers.enfants.number>0? (<>
              <p>Ce montant tient compte du complément pour les familles monoparentales</p>
            </>):''}
            <a href="tel:0891150451">
              <img src={banniere} alt="contact" />
            </a>
            
            
          </div>
        );
      }
      else {
        let montantPrime = getMontantPrimeAlter(props.answers.couple ,  props.answers.enfants.number);
        message = (
          <div>
            Selon les informations que vous nous avez fournies, vous devriez percevoir<br/>
            <strong>{montantPrime} €</strong> le 15 décembre 2023 
            <br/>
            
            { !props.answers.couple && props.answers.enfants.number>0? (<>
              <p>Ce montant tient compte du complément pour les familles monoparentales. Cependant pour l’obtenir, vous devez faire une demande auprès de Pôle emploi</p>
            </>):''}

            <a href="tel:0891150451">
              <img src={banniere} alt="contact" />
            </a>
      
            
          </div>
        );

      }

    }

  })

	return (
    <div className="questions"> 
    	<div className="resultat" >
          {(positive) ?
            <div className="zoneimage positif" ><img src={cadeau}/></div>
            :<div className="zoneimage negatif" ><img src={panneau}/></div>
          }

            <div className="zonereponse">
              <span className="reponsetitre" style={{"fontWeight": "bold" , "marginBottom": "15px"}}>{ (positive) ? "Bonnes nouvelles !" : "Désolé"}</span>
              <div className="qrow reponse">
                {message}
              </div>
              <div className="qrow centre"><button className="redemarre" onClick={props.restart}>Recommencer</button></div>
            </div>
            <div className="clear clearfix"></div>
      </div>
    </div>
  );
}